/**
 * `Touchable` is a meant to add some basic conveniences around improving touch experiences on
 * native mobile devices. It will, however, require you to still be thoughtful in your
 * implementation and testing to make sure you are providing a high quality native experience. You
 * are encouraged to test your usage of `Touchable` on all platforms, especially Android which is
 * known to need more complex handling of it's "ripple" effect.
 */

export {TouchableOpacity as Touchable} from 'react-native'
